import Banner from "../components/Banner";
import RegisterCallout from "../components/RegisterCallout";
import {
  Agenda,
  AgendaDay,
  AgendaEvent,
  AgendaSpeaker,
  AgendaBreakout,
} from "../components/Agenda";

import AgendaData25 from "../data/AgendaData25";

export default function PageAgenda() {
  return (
    <>
      <Banner className="bg-after-purple">
        <div className="col-12 col-md-8 pb-4">
          <div className="row">
            <div className="col-12 mb-3">
              <div className="display-1 color-white">Daily Agenda</div>
            </div>
            <div className="col-12 col-md-11 col-lg-10 col-xl-9 mb-2">
              <p className="color-white mb-0">
                FinComp 2025 is proudly approved by both the Society for Human
                Resource Management (SHRM) for 20 credit hours and the HR
                Certification Institute (HRCI) for 16 credit hours.
              </p>
            </div>
          </div>
        </div>
        <div className="col-4 text-end px-0 pb-4 d-none d-md-block">
          <img
            className="img-fluid"
            src="../img/logo-certs.webp"
            alt="HRCI and SHRM certifications"
          />
        </div>
      </Banner>
      <Agenda>
        {AgendaData25.map((day, dayIndex) => (
          <AgendaDay key={dayIndex} title={day.title}>
            {day.events.map((event, eventIndex) => (
              <AgendaEvent
                key={eventIndex}
                time={event.time}
                title={event.title}
                isKeynote={event.isKeynote}
              >
                {event.speakers?.map((s, i) => (
                  <AgendaSpeaker key={i} name={s.name} company={s.company} />
                ))}
                {event.description && <p>{event.description}</p>}

                {event.sessions?.map((session, i) => {
                  const speakers = session.speakers || [];
                  const multipleSpeakers = speakers.length > 1;

                  return (
                    <div key={i}>
                      <AgendaBreakout
                        count={session.count}
                        title={session.title}
                      />
                      {speakers.map(
                        (speaker, j) =>
                          speaker && (
                            <AgendaSpeaker
                              key={j}
                              name={speaker.name}
                              company={speaker.company}
                              className={multipleSpeakers ? "mb-2" : "my-2"}
                            />
                          )
                      )}
                      {session.description && (
                        <p
                          dangerouslySetInnerHTML={{
                            __html: session.description,
                          }}
                        />
                      )}
                    </div>
                  );
                })}
              </AgendaEvent>
            ))}
          </AgendaDay>
        ))}
      </Agenda>
      <RegisterCallout className="bg-before-purple" />
    </>
  );
}
